import { render, staticRenderFns } from "./CRUDTableNew.vue?vue&type=template&id=4e8a6581"
import script from "./CRUDTableNew.vue?vue&type=script&lang=js"
export * from "./CRUDTableNew.vue?vue&type=script&lang=js"
import style0 from "./CRUDTableNew.vue?vue&type=style&index=0&id=4e8a6581&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports